import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    background: 'Background',
    countryBorders: 'Country borders',
    openStreetMap: 'OpenStreetMap',
    infrastructure: 'Infrastructure',
    alarmZones: 'Alarm zones',
    lines: 'Lines',
    stations: 'Stations',
    others: 'others'
};

const hr = {
    background: 'Podloga',
    countryBorders: 'Granice zemalja',
    openStreetMap: 'OpenStreetMap',
    infrastructure: 'Infrastruktura',
    alarmZones: 'Alarm zone',
    lines: 'Vodovi',
    stations: 'Stanice',
    others: 'ostalo'
};

export const strings: Strings<typeof en> = {en, hr};
